import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ShippingPhoneNumberModal
*
* Encapsulates the functionality of a modal dialog that allows the user to edit their shipping address's phone number.
**/
HSN.ShippingPhoneNumberModal = (function(parent) {
    __extends(ShippingPhoneNumberModal, parent);

    function ShippingPhoneNumberModal() {
        /**
        * new HSN.ShippingPhoneNumberModal()
        **/
        var modal = ShippingPhoneNumberModal.__super__.constructor.call(this, 'editing-modal shipping-phone');

        HSN.FormatPhone($(this.Content).find('#Phone'));

        AddEventHandlers(this);

        return modal;
    }

    function AddEventHandlers(modal) {
        $(modal.Content).on('click', '#cancel', function() {
            $(modal.Close).click();
            return false;
        });
        $(modal.Content).on('click', '#apply', function () {
            HSN.SetWait();
            var form = $('#phone-ltl-form');
            var commerceService = HSN.Instance()._getCommerceService();
            commerceService.UpdateLtlShippingPhoneNumber(form.serialize(), {
                callback: function (data) {
                    if (data.success) {
                        window.location.reload();
                    } else {
                        HSN.RemoveWait();
                        HSN.AddErrorTreatment('#phone-ltl-form', data);
                    }
                },
                scope: this
            });
            return false;
        });
    }

    ShippingPhoneNumberModal.prototype._show = function (shippingAddressId) {
        var scope = this;
        scope.AddLoadingSpinner();
        $.ajax('/checkout/order-review/shipping-phone',
            {
                type : 'GET',
                context : this,
                dataType : 'html',
                data : { "shippingAddressId" : shippingAddressId },
                success : function(data) {
                    scope.RemoveLoadingSpinner();
                    this.Content.showHtml(
                        data,
                        0,
                        function() {
                            scope.Center();
                            scope.Content.animate({ opacity : 1 });
                            HSN.FormatPhone(scope.Content.find('#ltl-phone'));
                        }
                    );
                },
                error : function() {
                    alert('Unfortunately there was an error attempting to load the content, please try again.');
                    scope.RemoveLoadingSpinner();
                    scope.Hide();
                }
            }
        );
    };
    return ShippingPhoneNumberModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/Checkout/ShippingPhoneNumberModal.js